import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import React from 'react'

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const CommonSnackbar = ({
  open,
  onClose,
  message,
  severity = 'success',
  autoHideDuration = 3000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      sx={{ maxWidth: 420 }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          width: '100%',
          maxWidth: 420,
          alignItems: 'center',
          wordBreak: 'break-word',
          '& .MuiAlert-message': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default CommonSnackbar
